<div class="make-model-single" [ngClass]="{ 'make-model-single--error': error }">
  <div class="make-model-single__wrap">
    <button class="make-model-single__button" type="button" (focusout)="touch()"></button>
    @if (active) {
      <div class="make-model-single__box">
        <div class="make-model-single__box-header">
          <div class="make-model-single__box-logo">
            <app-image class="make-model-single__box-logo-img" [src]="active.logo" [alt]="active.make" [fill]="true" [placeholder]="false" [object-fit]="'contain'"></app-image>
          </div>
          {{ active.make }}
        </div>
        <app-tag [size]="'large'" [color]="'secondary'" [close]="true" (click)="remove()">{{ active.model }}</app-tag>
        <button class="make-model-single__close" type="button" (click)="remove()">
          <app-icon [icon]="'close-circle'" [width]="16"></app-icon>
        </button>
      </div>
    } @else {
      <app-make-model-dropdown [single]="true" [buyout]="true" [position]="'absolute'" [(value)]="value" [other-options]="otherOptions" (singleChange)="setActive($event)"></app-make-model-dropdown>
    }
  </div>
  @if (error) {
    <app-input-error class="make-model-single__error">
      {{ errorMessage }}
    </app-input-error>
  }
</div>
